module.exports = __webpack_public_path__ + "static/diversity-0b436936c91e6919c2a97033e9ef8872.png";